var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"textbookContent"}},[_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.bookInfo)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }